/**
 * Sleep Reset Academy — lesson-route resolver.
 * The canonical 42-lesson map comes from `GET /api/sleep-reset-academy/lesson-map`
 * (canonical YAML). No hardcoded pilot fallback: callers that must be correct
 * (e.g. the legacy /lesson/:id redirect) await `preloadAcademyLessonMap()`.
 */

const API = process.env.REACT_APP_BACKEND_URL;

let lessonMap = {};
let mapVersion = null;
let loaded = null;

export function preloadAcademyLessonMap() {
  if (loaded) return loaded;
  loaded = (async () => {
    try {
      const r = await fetch(`${API}/api/sleep-reset-academy/lesson-map`);
      if (!r.ok) throw new Error(`lesson-map http ${r.status}`);
      const j = await r.json();
      lessonMap = j.lessons || {};
      mapVersion = j.version || "unknown";
    } catch (e) {
      loaded = null; // allow retry on next call
      // eslint-disable-next-line no-console
      console.warn("[lessonRoute] lesson-map fetch failed", e);
    }
    return lessonMap;
  })();
  return loaded;
}

export function isCanonicalLesson(topicId) {
  const e = lessonMap[String(topicId)];
  return !!(e && e.published && (e.lesson_type === "presentation" || e.lesson_type === "multimodal"));
}

export function academyLessonPath(topicId) {
  const id = String(topicId);
  const entry = lessonMap[id];
  if (isCanonicalLesson(id)) return `/academy/sleep-reset/${entry.lesson_type}/${id}`;
  return `/academy/sleep-reset/lesson/${id}`;
}

/** Measured narration minutes for a canonical lesson, or null (label hidden). */
export function measuredLessonMinutes(topicId, language = "en") {
  const e = lessonMap[String(topicId)];
  return (e && e[`measured_minutes_${language === "es" ? "es" : "en"}`]) ?? null;
}

export function lessonMeta(topicId) {
  return lessonMap[String(topicId)] || null;
}

export function _lessonMapSnapshot() {
  return { version: mapVersion, size: Object.keys(lessonMap).length, map: lessonMap };
}
